// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3-ANh","icon":"SortAdornment_icon__wpnjX","up":"SortAdornment_up__6BkKh","down":"SortAdornment_down__3y2p1","active":"SortAdornment_active__1azun"};